/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Savingandpublishing2Inputs */

const en_savingandpublishing2 = /** @type {(inputs: Savingandpublishing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saving & Publishing...`)
};

const de_savingandpublishing2 = /** @type {(inputs: Savingandpublishing2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern & Veröffentlichen…`)
};

/**
* | output |
* | --- |
* | "Saving & Publishing..." |
*
* @param {Savingandpublishing2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const savingandpublishing2 = /** @type {((inputs?: Savingandpublishing2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Savingandpublishing2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_savingandpublishing2(inputs)
	return de_savingandpublishing2(inputs)
});
export { savingandpublishing2 as "savingAndPublishing" }